import EasyWin from './EasyWin';

export default EasyWin;
